import ClientDetails from './ClientDetails'
import CurrentMastitisSituation from './CurrentMastitisSituation'
import MastitisGoals from './MastitisGoals'
import MastitisControlMeasures from './MastitisControlMeasures'
import CowEnvironment from './CowEnvironment'
import DryCowStrategy from './DryCowStrategy'
import PreventiveHealthAndVacination from './PreventiveHealthAndVacination'
import DryOffProcess from './DryOffProcess'
import ThisSeasonDryOff from './ThisSeasonDryOff'
import DryCowAndTeatsealOrder from './DryCowAndTeatsealOrder'
import EmailNotifications from './EmailNotifications'
import Disclaimer from './Disclaimer'


export const dryCowConsultComponents = {
  ClientDetails,
  CurrentMastitisSituation,
  MastitisGoals,
  MastitisControlMeasures,
  CowEnvironment,
  DryCowStrategy,
  PreventiveHealthAndVacination,
  DryOffProcess,
  ThisSeasonDryOff,
  DryCowAndTeatsealOrder,
  EmailNotifications,
  Disclaimer,
}

